import { motion } from "framer-motion"
import type { ReactNode } from "react"
import { fadeUp } from "@/shared/lib/motion"

interface PageTransitionProps {
	children: ReactNode
}

export function PageTransition({ children }: PageTransitionProps) {
	return (
		<motion.div variants={fadeUp} initial="hidden" animate="visible" exit="exit">
			{children}
		</motion.div>
	)
}
